import { render, staticRenderFns } from "./memo.vue?vue&type=template&id=415d7c8f&"
import script from "./memo.vue?vue&type=script&lang=js&"
export * from "./memo.vue?vue&type=script&lang=js&"
import style0 from "./memo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports